import * as assert from 'assert';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import { FamilySettingsConstants as ui, FRESHDESK } from '../../Config/UIConstants';
import { FullContainer } from '../../SharedComponents/FullContainer';
import { CollectionGrid } from '../../SharedComponents/GridDisplay/CollectionGrid';
import { InformationIcon } from '../../SharedComponents/InformationIcon';
import {
    ActiveTabState,
    NavigationContainer,
} from '../../SharedComponents/MainPageWithNavigator/MainPageWithNavigator';
import { IUserFamily, IUserFromFamily } from '../../Stores/UserFamilyStore';
import { ApplicationStore } from '../../_stores/ApplicationStore';
import { InviteIcon, NoProfileImageUrl } from '../../images/images';

interface IProps {
    store: ApplicationStore;
}

// interface IState {
// }

@inject('store')
@observer
export class FamilyDetailPage extends React.Component<IProps & RouteComponentProps<any>> {
    public componentDidMount(): void {
        window.scrollTo(0, 0);
    }

    // public state: IState = {
    // };

    private renderItem = (user: IUserFromFamily | { email: string }) => {
        return (
            <FullContainer
                style={styles.container}
                onClick={
                    'id' in user
                        ? () =>
                              this.props.history.push(
                                  `${parseInt(this.props.match.params.id)}/familymember/${(user as IUserFromFamily).id}`,
                              )
                        : undefined
                }
            >
                {'id' in user
                    ? [
                          <img
                              key="img"
                              src={(user as IUserFromFamily).profileImageUrl}
                              style={styles.memberContainer}
                          />,
                          <div key="info" style={styles.diffuseContainer}>
                              <p className="TextShadow" style={styles.nameText}>
                                  {this.props.store.userFamilyStore.getFamilyMemberFullName(user as IUserFromFamily)}
                              </p>
                          </div>,
                      ]
                    : [
                          <img key="img" src={NoProfileImageUrl} style={styles.memberContainer} />,
                          <div key="info" style={styles.diffuseContainer}>
                              <div style={styles.inviteSentContainer}>
                                  <img src={InviteIcon} style={styles.inviteIcon} />
                                  <p style={styles.inviteSentText}>{ui.INVITE_SENT}</p>
                              </div>
                              <p className="TextShadow" style={styles.nameText}>
                                  {(user as { email: string }).email}
                              </p>
                          </div>,
                      ]}
            </FullContainer>
        );
    }

    private onClickAddMember(): void {
        const family = this.props.store.userFamilyStore.getFamilyByID(parseInt(this.props.match.params.id));

        this.props.history.push(`/addfamilymember/${family.id}`);
    }

    private renderNavigationContainerSubtitle = (family: IUserFamily): React.ReactNode => {
        return <React.Fragment>
            {this.props.store.userFamilyStore.getFamilyMemberFullName(family.creator)}
            <InformationIcon link={FRESHDESK.FAMILY_ADMINISTRATOR} style={styles.subtitleInfoIcon}/>
        </React.Fragment>;
    }

    public render() {
        if (
            !this.props.store.userFamilyStore ||
            !this.props.store.userFamilyStore.familiesAreLoaded
        ) {
            return null;
        }
        const family = this.props.store.userFamilyStore.getFamilyByID(parseInt(this.props.match.params.id));
        const isAdmin = this.props.store.userFamilyStore.isFamilyAdmin(family, this.props.store.userStore.currentUser);

        assert(family.members.length !== 0, 'A family with 0 members was loaded into family store');

        return (
            <NavigationContainer
                {...this.props}
                activeTabState={ActiveTabState.FAMILY_DETAIL}
                title={family.name}
                subTitle={this.renderNavigationContainerSubtitle(family)}
                primaryButton={
                    isAdmin
                        ? {
                              text: ui.ADD_MEMBER_BUTTON,
                              action: () => this.onClickAddMember(),
                          }
                        : undefined
                }
                secondaryButton={
                    isAdmin
                        ? {
                              text: ui.FAMILY_SETTINGS,
                              action: () => this.props.history.push(`/familysettings/${family.id}`),
                          }
                        : undefined
                }
            >
                <FullContainer>
                    <CollectionGrid
                        content={[...family.members, ...family.pendingMembers]}
                        renderItem={this.renderItem}
                    />
                </FullContainer>
            </NavigationContainer>
        );
    }
}

const styles = {
    container: {
        position: 'relative',
        backgroundColor: 'black',
        cursor: 'pointer',
    } as React.CSSProperties,
    memberContainer: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        objectPosition: 'center',
    } as React.CSSProperties,
    diffuseContainer: {
        position: 'absolute',
        bottom: 0,
        width: '100%',
        height: '100%',
        backgroundColor: '#00000022',
        display: 'flex',
        justifyContent: 'flex-end',
        flexDirection: 'column',
    } as React.CSSProperties,
    nameText: {
        color: 'white',
        fontSize: 20,
        fontWeight: 900,
        paddingBottom: 20,
        paddingLeft: 20,
    } as React.CSSProperties,
    inviteSentContainer: {
        top: 20,
        left: 20,
        height: 50,
        width: '100%',
        display: 'flex',
        position: 'absolute',
    } as React.CSSProperties,
    inviteIcon: {
        height: 20,
        width: 20,
    },
    inviteSentText: {
        fontSize: 18,
        color: 'white',
        fontWeight: 'bold',
        paddingLeft: 10,
    } as React.CSSProperties,
    subtitleInfoIcon: {
        height: '1em',
        width: '1em',
        marginLeft: '0.2em'
    } as React.CSSProperties
};



// WEBPACK FOOTER //
// ./src/Pages/FamiliesPage/FamilyDetailPage.tsx